module.exports = __webpack_public_path__ + "img/tab-tool-settings.a94e00f0.svg";